import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { makeStyles } from '@mui/styles';
import Geonames from 'geonames.js';
import { Autocomplete, Box, TextField } from '@mui/material';
import { Grid, width } from '@mui/system';

const geonames = new Geonames({
    username: 'thalesandrade', // use your geonames username
    lan: 'en',
    encoding: 'JSON',
});

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: '100%',
        marginBottom: theme.spacing(2),
    },
}));

export default function GeoLocation({ onChange, fields, filters, isDashboard, isDirection }) {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);

    // Load countries
    useEffect(() => {
        geonames.countryInfo({}).then((res) => {
            setCountries(res.geonames || []);
        });
    }, []);

    useEffect(() => {
        if (selectedCountry) {
            geonames.children({ geonameId: selectedCountry.geonameId }).then((res) => {
                const stateList = res.geonames || [];
                setStates(stateList);
            });
        } else {
            setStates([]);
            setSelectedState(null);
            setCities([]);
            setSelectedCity(null);
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedState) {
            geonames.children({ geonameId: selectedState.geonameId }).then((res) => {
                const cityList = res.geonames || [];
                setCities(cityList);
            });
        } else {
            setCities([]);
            setSelectedCity(null);
        }
    }, [selectedState]);

    useEffect(() => {
        if (countries.length > 0 && (fields?.country || filters?.country)) {
            const countryObj = countries.find(
                (c) => c.countryName === (fields?.country || filters?.country)
            );
            if (countryObj) setSelectedCountry(countryObj);
        }
    }, [countries, fields, filters]);

    useEffect(() => {
        if (states.length > 0 && (fields?.state || filters?.state)) {
            const stateObj = states.find(
                (s) => s.name === (fields?.state || filters?.state)
            );
            if (stateObj) setSelectedState(stateObj);
        }
    }, [states, fields, filters]);

    useEffect(() => {
        if (cities.length > 0 && (fields?.city || filters?.city)) {
            const cityObj = cities.find(
                (c) => c.name === (fields?.city || filters?.city)
            );
            if (cityObj) setSelectedCity(cityObj);
        }
    }, [cities, fields, filters]);

    const handleCountryChange = (event, value) => {
        setSelectedCountry(value);
        setSelectedState(null);
        setSelectedCity(null);
        onChange({ country: value?.countryName || "", state: "", city: "" });
    };

    const handleStateChange = (event, value) => {
        setSelectedState(value);
        setSelectedCity(null);
        onChange({
            country: selectedCountry?.countryName || "",
            state: value?.name || "",
            city: "",
        });
    };

    const handleCityChange = (event, value) => {
        setSelectedCity(value);
        onChange({
            country: selectedCountry?.countryName || "",
            state: selectedState?.name || "",
            city: value?.name || "",
        });
    };

    return (
        <Box mt={2} sx={{ display: "flex", gap: "4px", flexDirection: isDirection ? "column" :"row"}} >

            <Autocomplete

                options={countries}
                getOptionLabel={(option) => option.countryName}
                value={selectedCountry}
                onChange={handleCountryChange}
                renderInput={(params) => <TextField {...params} label="Country" sx={{ width: isDirection ? "180px"  :"300px" }} />}
            />

            <Autocomplete

                options={states}
                getOptionLabel={(option) => option.name}
                value={selectedState}
                onChange={handleStateChange}
                renderInput={(params) => <TextField {...params} label="State" sx={{ width: isDirection ? "180px"  :"300px" }} />}
                disabled={!selectedCountry}
            />

            <Autocomplete
                options={cities}
                getOptionLabel={(option) => option.name}
                value={selectedCity}
                onChange={handleCityChange}
                renderInput={(params) => <TextField {...params} label="City" sx={{ width: isDirection ? "180px"  :"300px" }} />}
                disabled={!selectedState}
            />

        </Box>
    );
}